export default __webpack_public_path__ + "static/media/fruit25.4bb1991f.jpg";